import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import facilitiesAPI from "../api/facilitiesApi";
import facultyAPI from "../api/facultyApi";
import CareerForm from "../modal/CareerForm";

const Career = () => {
  const [benefitList, setBenefitList] = useState([]);
  const [jobData, setJobData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [activeJob, setActiveJob] = useState("");

  useEffect(() => {
    fetchCareerData();
  }, []);

  const fetchCareerData = async () => {
    const [res1, res2] = await Promise.all([
      facultyAPI.career(),
      facultyAPI.faculty_join(),
    ]);

    if (res1.code === 200) {
      setBenefitList(res1.data?.["career"] || []);
    }

    if (res2.code === 200) {
      setJobData(res2.data?.["join-faculty"] || []);
    }
  };

  const benefitsInfo = benefitList?.[0];

  const openForm = (title) => {
    setActiveJob(title);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeForm = () => {
    setShowModal(false);
    document.body.style.overflow = "auto";
  };

  // const jobData = [
  //   { id: 1, title: "PGT Mathematics", dept: "Senior Wing", exp: "3-5 Years" },
  //   { id: 2, title: "Primary Teacher", dept: "Junior Wing", exp: "1-3 Years" },
  //   {
  //     id: 3,
  //     title: "Physical Education",
  //     dept: "Sports Dept",
  //     exp: "2+ Years",
  //   },
  //   {
  //     id: 4,
  //     title: "Lab Assistant",
  //     dept: "Science Dept",
  //     exp: "Freshers Welcome",
  //   },
  // ];
  return (
    <>
      <BreadCrumbBanner
        title="Careers"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
        loading="lazy"
      />
      <section className="mrv-career-form-section">
        <div className="container">
          <div className="text-center mb-5">
            <span className="mrv-subtitle">JOIN OUR TEAM</span>
            <h2 className="mrv-title">Shape Young Minds, Shape Your Future.</h2>
          </div>
          <div className="mrv-career-form-list-wrapper">
            {jobData.map((job) => (
              <div key={job.id} className="mrv-career-form-job-item">
                <div className="mrv-career-form-info-block">
                  <h4 className="mrv-career-form-job-title">{job.branch}</h4>{" "}
                  <div className="mrv-career-form-meta-group">
                    <span className="mrv-career-form-badge">{job.subject}</span>{" "}
                    <span className="text-muted small">
                      <i className="bi bi-clock-history"></i>{" "}
                      {job.experience}{" "}
                    </span>
                  </div>
                </div>
                <button
                  className="mrv-career-form-apply-btn"
                  onClick={() => openForm(job.branch)}
                >
                  APPLY NOW
                </button>
              </div>
            ))}
          </div>
          <CareerForm
            showModal={showModal}
            activeJob={activeJob}
            closeForm={closeForm}
          />

          {/* {showModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(15, 23, 42, 0.9)", zIndex: 1060 }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered px-3">
                <div className="modal-content mrv-career-form-modal-box">
                  <div className="mrv-career-form-modal-header d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="mb-0 fw-bold text-white">
                        Application Form
                      </h5>
                      <span className="small text-light opacity-75">
                        Position: {activeJob}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={closeForm}
                    ></button>
                  </div>

                  <div className="mrv-career-form-modal-body">
                    <form className="container-fluid px-0">
                      <div className="row row-cols-1 row-cols-md-2 g-4">
                        <div className="col text-start">
                          <label className="mrv-career-form-label">
                            Full Name
                          </label>
                          <input
                            type="text"
                            className="mrv-career-form-input"
                            placeholder="Name"
                            required
                          />
                        </div>
                        <div className="col text-start">
                          <label className="mrv-career-form-label">
                            Contact Number
                          </label>
                          <input
                            type="tel"
                            className="mrv-career-form-input"
                            placeholder="+91..."
                            required
                          />
                        </div>
                        <div className="col text-start">
                          <label className="mrv-career-form-label">
                            Email ID
                          </label>
                          <input
                            type="email"
                            className="mrv-career-form-input"
                            placeholder="email@school.com"
                            required
                          />
                        </div>
                        <div className="col text-start">
                          <label className="mrv-career-form-label">
                            Total Experience
                          </label>
                          <input
                            type="text"
                            className="mrv-career-form-input"
                            placeholder="Years"
                            required
                          />
                        </div>
                      </div>

                      <div className="mt-4 text-start">
                        <label className="mrv-career-form-label">
                          Resume (PDF)
                        </label>
                        <input
                          type="file"
                          className="mrv-career-form-input"
                          accept=".pdf"
                          required
                        />
                      </div>

                      <div className="mt-4 text-start">
                        <label className="mrv-career-form-label">
                          Teaching Methodology
                        </label>
                        <textarea
                          className="mrv-career-form-input"
                          rows="3"
                          placeholder="Briefly explain your approach..."
                        ></textarea>
                      </div>
                      <div className="d-flex justify-content-center align-items-center">
                        <button
                          type="submit"
                          className="mrv-career-form-submit-btn "
                        >
                          SUBMIT APPLICATION
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )} */}
        </div>
      </section>

      {benefitList.length > 0 && (
        <section className="career-mrv-benefits-section">
          <div className="container">
            {/* Bento Grid Content */}
            <div className="career-mrv-bento-grid">
              {benefitList.map((item, index) => (
                <div className="career-mrv-benefit-card" key={index}>
                  <div className="career-mrv-icon-box">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="library-icon"
                      loading="lazy"
                    />
                  </div>
                  <h4>{item.title}</h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item?.description || "",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Career;
